import { createFileRoute } from '@tanstack/react-router';
import { BookOpen } from 'lucide-react';
import { useCurrentBatch } from '@/lib/hooks/useCurrentBatch';
import { EmptyState } from '@/components/EmptyState';
import { CourseCard } from '@/features/Course/CourseCard';

export const Route = createFileRoute('/_student/courses/')({
  component: CoursesIndex,
});

function CoursesIndex() {
  const { batches, isLoading } = useCurrentBatch();

  if (isLoading) {
    return (
      <div className="mx-auto max-w-[1100px] p-4 sm:p-6 text-muted-foreground">
        Loading your courses…
      </div>
    );
  }

  if (!batches || batches.length === 0) {
    return (
      <div className="mx-auto max-w-[1100px] p-4 sm:p-6">
        <EmptyState
          icon={BookOpen}
          title="No courses yet"
          description="You haven't been enrolled in any courses. Contact your trainer or admin to get started."
        />
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-[1100px] p-4 sm:p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-heading font-bold text-[#1a1714]">My Batches</h1>
        <p className="text-sm text-[#9a9589] mt-1">Access your batches and continue learning.</p>
      </div>
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-2">
        {batches.map((batch, i) => (
          <CourseCard key={batch.id} batch={batch} index={i} />
        ))}
      </div>
    </div>
  );
}
